import { Box } from '@mui/system';
import Link from 'next/link';
import { useRouter } from 'next/router';

const BrandIcon = props => {
  const router = useRouter();
  return (
    <Link
      href={props.url}
      passHref
      underline='none'
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          router.push(props.url);
        }
      }}
    >
      <Box
        component='img'
        src={props.src}
        alt='eir go back to the homepage'
        sx={{ width: '100%', height: 'auto', p: 0.5, maxWidth: 90 }}
      />
    </Link>
  );
};

export default BrandIcon;
